/**
 * Direction primitives — shared by movement, AI, and rendering.
 * Stable order is N, E, S, W; tie-breaking elsewhere assumes this.
 */

import type { Direction } from './types.ts';

export const DIRECTIONS: readonly Direction[] = ['N', 'E', 'S', 'W'] as const;

export type Vector = { readonly dx: number; readonly dy: number };

const N: Vector = { dx: 0, dy: -1 };
const E: Vector = { dx: 1, dy: 0 };
const S: Vector = { dx: 0, dy: 1 };
const W: Vector = { dx: -1, dy: 0 };

export function dirVec(d: Direction): Vector {
  switch (d) {
    case 'N': return N;
    case 'E': return E;
    case 'S': return S;
    case 'W': return W;
  }
}

export function opposite(d: Direction): Direction {
  switch (d) {
    case 'N': return 'S';
    case 'E': return 'W';
    case 'S': return 'N';
    case 'W': return 'E';
  }
}

export function isReverse(a: Direction, b: Direction): boolean {
  return opposite(a) === b;
}
